import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Notyf } from "notyf";
import exportValue from "../apiconfig";

const Forgot_password = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const notyf = new Notyf();

  const [state, setState] = useState({
    email: "",
    otp: "",
    old_password: "",
    new_password: "",
    otp_sent: false,
    otp_verified: false,
  });

  useEffect(() => {
    const email = searchParams.get("email");

    if (email) {
      setState((prev) => ({
        ...prev,
        email: email,
      }));
    }
  }, []);

  const handleChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  // SEND OTP
  const sendOtp = () => {
    let full_api =
      exportValue.host +
      "/" +
      exportValue.version +
      "/" +
      exportValue.api +
      `/send_forgot_password_otp`;

    axios
      .post(
        full_api,
        { email: state.email },
        { headers: exportValue.headers }
      )
      .then((res) => {
        if (res.data.status) {
          notyf.success("OTP sent successfully");

          setState((prev) => ({
            ...prev,
            otp_sent: true,
          }));
        } else {
          notyf.error(res.data.message);
        }
      });
  };

  // VERIFY OTP
  const verifyOtp = () => {
    let full_api =
      exportValue.host +
      "/" +
      exportValue.version +
      "/" +
      exportValue.api +
      `/verify_forgot_password_otp`;

    axios
      .post(
        full_api,
        {
          email: state.email,
          otp: state.otp,
        },
        { headers: exportValue.headers }
      )
      .then((res) => {
        if (res.data.status) {
          notyf.success("OTP verified");

          setState((prev) => ({
            ...prev,
            otp_verified: true,
          }));
        } else {
          notyf.error(res.data.message);
        }
      });
  };

  // RESET PASSWORD
  const resetPassword = () => {
    let full_api =
      exportValue.host +
      "/" +
      exportValue.version +
      "/" +
      exportValue.api +
      `/reset_password`;

    axios
      .post(
        full_api,
        {
          email: state.email,
          old_password: state.old_password,
          new_password: state.new_password,
        },
        { headers: exportValue.headers }
      )
      .then((res) => {
        if (res.data.status) {
          notyf.success("Password updated successfully");

          setTimeout(() => {
            navigate("/login");
          }, 1500);
        } else {
          notyf.error(res.data.message);
        }
      });
  };

  return (
    <div>
      <section className="vh-lg-100 mt-5 mt-lg-0 bg-soft d-flex align-items-center">
        <div className="container">
          <div className="row justify-content-center form-bg-image">
            <div className="col-12 d-flex align-items-center justify-content-center">
              <div className="bg-white shadow border-0 rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                <div className="text-center mb-4">
                  <h1 className="mb-0 h3">Reset Password</h1>
                </div>

                {/* EMAIL */}
                <div className="form-group mb-4">
                  <label>Email</label>

                  <input
                    type="email"
                    className="form-control"
                    value={state.email}
                    disabled
                  />
                </div>

                {/* SEND OTP */}
                {!state.otp_sent && (
                  <button
                    className="btn btn-primary w-100 mb-3"
                    onClick={sendOtp}
                  >
                    Send OTP
                  </button>
                )}

                {/* OTP */}
                {state.otp_sent && !state.otp_verified && (
                  <>
                    <div className="form-group mb-4">
                      <label>Enter OTP</label>

                      <input
                        type="text"
                        className="form-control"
                        name="otp"
                        onChange={handleChange}
                        value={state.otp}
                      />
                    </div>

                    <button
                      className="btn btn-success w-100 mb-3"
                      onClick={verifyOtp}
                    >
                      Verify OTP
                    </button>
                  </>
                )}

                {/* PASSWORD RESET */}
                {state.otp_verified && (
                  <>
                    <div className="form-group mb-4">
                      <label>Old Password</label>

                      <input
                        type="password"
                        className="form-control"
                        name="old_password"
                        onChange={handleChange}
                      />
                    </div>

                    <div className="form-group mb-4">
                      <label>New Password</label>

                      <input
                        type="password"
                        className="form-control"
                        name="new_password"
                        onChange={handleChange}
                      />
                    </div>

                    <button
                      className="btn btn-primary w-100"
                      onClick={resetPassword}
                    >
                      Update Password
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Forgot_password;